// src/components/UpcomingEvents.js
import React, { useContext } from 'react';
import { EventsContext } from '../context/EventsContext';
import { Link } from 'react-router-dom';
import EventCard from './EventCard';

const UpcomingEvents = () => {
  const { events } = useContext(EventsContext);

  // Filter events that are in the future
  const today = new Date();
  const upcomingEvents = events
    .filter((event) => new Date(event.event_date) >= today)
    .sort((a, b) => new Date(a.event_date) - new Date(b.event_date));

  // Limit to the next 9 upcoming events (3 per slide x 3 slides)
  const limitedEvents = upcomingEvents.slice(0, 9);

  // Group events into chunks of 3 for the carousel slides
  // This gives us 3 cards per slide
  const slides = [];
  for (let i = 0; i < limitedEvents.length; i += 3) {
    slides.push(limitedEvents.slice(i, i + 3));
  }

  return (
    <section id="upcome" className="pt-4 pb-5">
      <div className="container">
        <div className="row trend_1">
          <div className="col-md-6 col-6">
            <div className="trend_1l">
              <h4 className="mb-0 text-white">
                <i className="fa fa-calendar align-middle col_red me-1"></i>
                Upcoming <span className="col_red">Events</span>
              </h4>
            </div>
          </div>
          <div className="col-md-6 col-6">
            <div className="trend_1r text-end">
              <h6 className="mb-0">
                <Link className="button" to="/events">
                  View All
                </Link>
              </h6>
            </div>
          </div>
        </div>
        <div className="row trend_2 mt-4">
          <div id="carouselExampleCaptions2" className="carousel slide position-relative" data-bs-ride="carousel">
            {/* Carousel Indicators */}
            <div className="carousel-indicators">
              {slides.map((_, index) => (
                <button
                  key={index}
                  type="button"
                  data-bs-target="#carouselExampleCaptions2"
                  data-bs-slide-to={index}
                  className={index === 0 ? 'active' : ''}
                  aria-label={`Slide ${index + 1}`}
                ></button>
              ))}
            </div>
            {/* Carousel Items */}
            <div className="carousel-inner">
              {slides.map((slideEvents, slideIndex) => (
                <div
                  key={slideIndex}
                  className={`carousel-item ${slideIndex === 0 ? 'active' : ''}`}
                >
                  <div className="trend_2i row"> 
                    {/* No additional column div here - EventCard already has column classes */}
                    {slideEvents.map((event) => (
                      <EventCard key={event.id} event={event} />
                    ))}
                  </div>
                </div>
              ))}
            </div>
            {/* Carousel Controls - Moved further out */}
            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleCaptions2"
              data-bs-slide="prev"
              style={{ left: "-50px", width: "40px" }}
            >
              <span className="carousel-control-prev-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Previous</span>
            </button>
            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleCaptions2"
              data-bs-slide="next"
              style={{ right: "-50px", width: "40px" }}
            >
              <span className="carousel-control-next-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        
        {/* Add some custom CSS for better controls positioning */}
        <style jsx="true">{`
          #carouselExampleCaptions2 .carousel-control-prev,
          #carouselExampleCaptions2 .carousel-control-next {
            border-radius: 50%;
            height: 40px;
            width: 40px;
            top: 50%;
            transform: translateY(-50%);
            opacity: 0.8;
          }
          
          #carouselExampleCaptions2 .carousel-control-prev {
            left: -50px;
          }
          
          #carouselExampleCaptions2 .carousel-control-next {
            right: -50px;
          }
          
          /* Make control icons more visible without background */
          #carouselExampleCaptions2 .carousel-control-prev-icon,
          #carouselExampleCaptions2 .carousel-control-next-icon {
            filter: drop-shadow(0px 0px 3px rgba(255, 54, 54, 0.9));
          }
          
          @media (max-width: 767px) {
            #carouselExampleCaptions2 .carousel-control-prev {
              left: -20px;
            }
            
            #carouselExampleCaptions2 .carousel-control-next {
              right: -20px;
            }
          }
        `}</style>
      </div>
    </section>
  );
};

export default UpcomingEvents;
